import logo from './logo.svg';
import './App.css';
import Dashboard from './dashboard/Dashboard'

function App() {
  return (
    <div className="App">
      <Dashboard></Dashboard>
    </div>
  );
}

export default App;
